export interface SliderScaleAnswer {
  value: number;
  touched: boolean;
}

export const isSliderScaleAnswer = (v: unknown): v is SliderScaleAnswer =>
  typeof v === 'object' &&
  v !== null &&
  typeof (v as SliderScaleAnswer).value === 'number' &&
  typeof (v as SliderScaleAnswer).touched === 'boolean';

/** Shown after an answer the respondent never moved off the default (mirrors the CSV export). */
export const SLIDER_UNTOUCHED_NOTE = ' (default, not moved)';

export const sliderAnswerText = (a: SliderScaleAnswer): string =>
  a.touched ? String(a.value) : `${a.value}${SLIDER_UNTOUCHED_NOTE}`;
